import styled from "styled-components";
import {rem} from "@/styles/theme";

export const Container = styled.div`
  display: flex;
  padding: ${rem(16)};
`

